<template>
  <div>
    <input type="hidden" name="name" :value="name" />

    <div ref="questions">
      <div v-if="questions.length !== 0">
        <div id="question-component" class="question-component">
          <survey-question
            @delete-event="deleteHandler"
            @up-event="upHandler"
            @low-event="lowHandler"
            :prestations="prestations"
            :tagcategories="tagcategories"
            v-for="(question, index) in questions"
            :key="index"
            :question="question"
            :identifier="question.id"
            :categories="categories"
          ></survey-question>
        </div>
      </div>
    </div>
    <div class="row mb-5">
      <div id="addQuestion" class="add_new_question d-flex container justify-content-center mb-5" @click="addQuestion">
        <i class="fa fa-2x fa-plus me-1"></i>
      </div>
    </div>
    <div id="survey-save-container" class="fixed-bottom bg-white shadow-lg">
      <button
        class="btn-success d-flex dontainer justify-content-center save_question_form mx-auto my-auto mb-3 mt-3 p-2 rounded"
      >
        <i class="fas fa-fw fa-save"></i>
        Fermer
      </button>
    </div>
  </div>
</template>

<script>
import SurveyQuestion from './SurveyQuestion.vue'

export default {
  name: 'SurveyForm',
  props: ['questionsprops', 'name', 'prestations', 'tagcategories', 'categories'],
  data: () => ({
    test: 0,
    questions: [],
    // components: { SurveyQuestion },
    // questionsLength: 0,
    // currentQuestion: {
    //     answers_possibilities: [],
    //     created_at: new Date(),
    //     id: 0,
    //     is_in_customer_card: 0,
    //     question: "",
    //     survey_id: 1,
    //     type: "0",
    //     updated_at: new Date(),
    // },
    // componentKey: 1
  }),
  mounted() {
    this.questionsLength = this.questions.length
    this.componentKey = this.questionsLength
    this.questions = Object.values(this.questionsprops)
  },
  methods: {
    addQuestion() {
      const empty_question = {
        answers_possibilities: [],
        prestations: [],
        created_at: new Date(),
        id: this.questions.length,
        is_in_customer_card: false,
        question: '',
        is_disabled: 0,
        survey_id: 1,
        type: '0',
        updated_at: new Date(),
      }
      this.questions.push(empty_question)
      console.log(this.questions)
      this.$forceUpdate()
    },
    upHandler(index) {
      if (index >= 1) {
        const a = this.questions[index]
        const b = this.questions[index - 1]
        this.questions[index] = b
        this.questions[index - 1] = a
        this.$forceUpdate()
      }
    },
    lowHandler(index) {
      console.log(this.questions)
      if (index < this.questions.length - 1) {
        const a = this.questions[index]
        const b = this.questions[index + 1]
        this.questions[index] = b
        this.questions[index + 1] = a
        console.log(this.questions)
        this.$forceUpdate()
      }
    },
    deleteHandler(index) {
      this.questions.splice(index, 1)
      this.$forceUpdate()
    },
  },
}
</script>

<style>
#survey-save-container {
  /* margin-left: 240px; */
  box-shadow: 0 3px -6px rgba(0, 0, 0, 0.16), 0 3px -6px rgba(0, 0, 0, 0.23);
}

.save_question_form {
  line-height: 1;
  font-size: 20px;
}

.save_question_form i {
  margin-right: 5px;
}

@media screen and (max-width: 991px) {
  #survey-save-container {
    margin-left: 0px;
  }
}
</style>
